import { Component, Input } from '@angular/core';
import { LocationsProvider } from '../../providers/locations/locations';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import moment from 'moment';
import { PopoverController } from 'ionic-angular';
import { CoCalendarComponent } from '../co-calendar/co-calendar';
/**
 * Generated class for the CoLocationHoursComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-location-hours',
  templateUrl: 'co-location-hours.html',
  inputs: ['location']
})
export class CoLocationHoursComponent {

  weekHoursArray: Array<Object>;
  weekDatesArray: Array<string> = [];
  dateRequested: string;
  buttonClicks: number = 0;
  weekEndInfo: any = [];
  currentDay: any = moment().startOf('day').format("YYYY-MM-DD HH:mm:ss");
  @Input("location") location: any;

  constructor(public locationsProvider: LocationsProvider, public navParams: NavParams, private popoverCtrl : PopoverController) {
  }

  ngOnInit(){
    if (this.navParams.data.location){
      this.getWeekHours("initial", this.navParams.data.location, "");
    } else {
      this.getWeekHours("initial",this.location, "");
    }
  };

  openDatePicker(id){
    let popover = this.popoverCtrl.create(CoCalendarComponent, { popup: true, range: false }, { cssClass: 'date-time-popover' });
    popover.present();

    popover.onDidDismiss(data => {
      if(data && data.date){
        this.buttonClicks = 0;
        let diff = (moment(data.date).startOf('day').diff(moment().startOf('day'), 'days'));
        this.buttonClicks = this.buttonClicks + diff;
        this.dateRequested = moment().add(this.buttonClicks, 'days').format("MM/DD/YYYY");

        this.locationsProvider.getWeekHours(id, this.dateRequested).then( data => {
          this.weekHoursArray = data;
        });

        this.weekDatesArray = [];
        console.log(this.dateRequested);
        for (let i = 0; i < 7; i++) {
          this.weekDatesArray.push(moment(this.dateRequested, "MM/DD/YYYY").startOf('week').add(i, "days").format("YYYY-MM-DD HH:mm:ss"));
        }
        this.weekEndInfo = []
        this.weekEndInfo.push(this.weekDatesArray[0], this.weekDatesArray[this.weekDatesArray.length-1])
        return this.weekHoursArray;
      }
    });
  }

  getWeekHours(direction: string, id: number, event) {

      if (direction === "previous"){
        this.buttonClicks = this.buttonClicks - 7
        this.dateRequested = moment().add(this.buttonClicks, "days").calendar().toString();
      } else if (direction === "next") {
        this.buttonClicks = this.buttonClicks + 7
        this.dateRequested = moment().add(this.buttonClicks, "days").calendar().toString();
      } else if (direction === "current") {
        this.buttonClicks = 0;
        this.dateRequested = moment().calendar().toString();
      } else {
        this.dateRequested = moment().format("MM/DD/YYYY");
      }


      if (this.buttonClicks == 0) {
        this.dateRequested = moment().format("MM/DD/YYYY");
      }

      this.locationsProvider.getWeekHours(id, this.dateRequested).then( data => {
        this.weekHoursArray = data;
      });

      this.weekDatesArray = [];
      for (let i = 0; i < 7; i++) {
        this.weekDatesArray.push(moment(this.dateRequested, "MM/DD/YYYY").startOf('week').add(i, "days").format("YYYY-MM-DD HH:mm:ss"));
      }
      this.weekEndInfo = []
      this.weekEndInfo.push(this.weekDatesArray[0], this.weekDatesArray[this.weekDatesArray.length-1])
      return this.weekHoursArray;
    }
}



// WEBPACK FOOTER //
// ./src/components/co-location-hours/co-location-hours.ts